import React, { useEffect } from 'react'
import './BuildReports.css'
import BuildRepoStart from "../../../Component/BuildRepoStart";
import moment from 'moment';
import { useUserData } from '../../../Providers/UserWrapper';
import { useLanguage } from '../../../Providers/LanguageContext';
import { useNavigate } from 'react-router-dom';

function BuildReport() {
  const { profileData } = useUserData()
  const navigate = useNavigate();
  const { language, currentLanguage } = useLanguage()

  console.log("profileDataxc", profileData?.name)

  useEffect(() => {
    window.scrollTo({ top: '0', behavior: 'instant' })
  }, [])
  return (
    <>
      <section style={{
        background: 'linear-gradient(rgba(15, 36, 55, 1), rgb(255, 255, 255))',

      }}>
        {/* <div className="try_fisibilty_wrapper " style={{
          transform: 'translateY(0%)',
          margin: '0px',
          justifyContent: 'start',
          background: '#031f31ff'

        }}>
          <div className="container-fluid">
            <p className="text-left">Reports Manager / Build Report</p></div>
        </div> */}

        <div className='container-fluid'>
          <div className='task_head'>Build Reports</div>
        </div>
        <div className='container-fluid mt-3'>
          <button className='slctUser' style={{
            background: 'rgb(136, 233, 132)',
            fontWeight: '500',
            color: '#0c2637'
          }}
            onClick={() => navigate('/view_reports')}>
            {language.view_reports}
          </button>
        </div>
        <div className="container-fluid pt-3 mt-3" style={{
          border: '4px solid #fff',
          borderRadius: '25px',
          padding: '30px 30px'
        }}>
          <div className="buildReprtTop">
            <ul>
              <li><span className='buildtopSpn' >{language?.company_name} : </span> {profileData && profileData?.companyName}</li>
              <li><span className='buildtopSpn' >{language?.report_generated_by} : </span> {profileData?.name + " " + profileData?.surName}</li>
              <li><span className='buildtopSpn' >{language?.report_generated_on} : </span> {moment().format("LL")}</li>
              {/* <li><span className='buildtopSpn'>Report Period:</span> 01.02.23 - 27.02.24</li> */}
            </ul>
          </div>

          <div className='buildRepoSection mt-4'>
            <BuildRepoStart />
          </div>
        </div>
      </section>
    </>
  )
}

export default BuildReport